import {lazy, Suspense} from "react";
import { PageSkeleton } from "../../customs/skeleton/main";


const Main = lazy(() => import("../../components/application/licenseRenewal/main"));

const LicenseRenewal = () => {

    return(

        <Suspense fallback={<PageSkeleton />}>
            <Main/>
        </Suspense>
      
    )
};

export default LicenseRenewal;